/**
 * Generated from ch3_p06.fla
 */
export function ch3_p06(this: Ich3_p06) {
	const bg = this.bg;
	ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframe_1.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_holly.call(this.holly);
	holly.x = 944.25;
	holly.y = 384;
	holly.width = 863.50;
	holly.height = 768.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const glow = this.glow;
	ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_glow.call(this.glow);
	glow.x = 860.25;
	glow.y = 384;
	glow.width = 1285.50;
	glow.height = 768.00;
	glow.alpha = 1.00;
	if (glow.onLayout) glow.onLayout();
	const frameRight = this.frameRight;
	ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy2.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframe_1(this: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframe_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p06_wcframe_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_holly(this: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p06_holly", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_glow(this: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_glow) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp3_p06_glow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy(this: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Pixellayercopy", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy2(this: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Pixellayercopy2", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich3_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich3_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich3_p06Sprite extends Ich3_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich3_p06Text extends Ich3_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich3_p06Polygon extends Array<number> {
}
interface Ich3_p06 {
	readonly bg: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframe_1;
	readonly holly: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_holly;
	readonly glow: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_glow;
	readonly frameRight: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy;
	readonly frameLeft: Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy2;
}
interface Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframe_1 extends Ich3_p06Sprite {
}
interface Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_holly extends Ich3_p06Sprite {
}
interface Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_glow extends Ich3_p06Sprite {
}
interface Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy extends Ich3_p06Sprite {
}
interface Ich3_p06_hh_ch3_72dpi_p06psdAssetchp3_p06_wcframePixellayercopy2 extends Ich3_p06Sprite {
}
